@if (isReadOnly()) {
  @if (!!this.currentItinerary()) {
    <div class="w-full h-full">
      <p-tabs
        [value]="selectedTravellerId()"
        (valueChange)="onTravellerTabChange($event)"
      >
        <div class="bg-white">
          <p-tablist>
            @for (traveller of sortedTravellers(); track traveller; let ii = $index) {
              <p-tab [value]="traveller.travellerId ?? 0">
                @if (traveller.travellerId === taSubmission()?.primaryTraveller?.travellerId) {
                  <i class="fa fa-star text-yellow-500"></i>
                } @else if (traveller.travellerId && this.taSubmissionDatasource.primaryLinkedUserTravellers().includes(traveller.travellerId)) {
                  <i class="fa fa-link"></i>
                } @else {
                  <i class="fa fa-link-slash"></i>
                }
                <span class="pl-1">
                  {{traveller.details?.firstName + " " + traveller.details?.surname }}
                </span>
              </p-tab>
            }
          </p-tablist>
        </div>
      </p-tabs>
      <div class="flex flex-col gap-2 pt-4">
        <p-table [value]="flightRows()" [tableStyle]="{ 'min-width': isFlightOnly() ? null : '60rem' }" size="small" class="border-[1px] border-surface-400 rounded table-auto w-fit max-w-full">
          <ng-template #header>
            <tr class="text-surface-800 text-xs font-semibold font-['Roboto_Condensed']">
              @if (isFlightOnly()) {
                <th class="rounded-tl"></th>
                <th>Date</th>
                <th>Departing From</th>
                <th>Flight Time</th>
                <th>Arriving At</th>
                <th>Arrival Time</th>
                <th class="rounded-tr">Flight Number</th>
              } @else {
                <th class="rounded-tl" pTooltip="Personal Days">PD</th>
                <th class="rounded-tl">Date</th>
                <th class="grow">Location</th>
                <th>Start</th>
                <th>Location</th>
                <th>End</th>
                <th>Work Type</th>
                <th>Mode of Travel</th>
                <th>Supporting Info</th>
                <th>Accommodation</th>
                <th>Breakfast</th>
                <th>Lunch</th>
                <th>Dinner</th>
                <th>Incidentals</th>
                <th>Catering</th>
                @if (showOverseasColumn()) {
                  <th>Overseas</th>
                }
                <th class="rounded-tr">Day Trip Rate</th>
              }
            </tr>
          </ng-template>
          <ng-template #body let-itineraryItem let-rowIndex="rowIndex">
            @if (itineraryItem.placeholder) {
              <tr class="text-surface-400 text-xs font-['Roboto_Condensed'] bg-surface-100" pTooltip="Not needed - this TA is for a one-way flight">
                <td class="font-semibold text-nowrap rounded-bl">Second Flight</td>
                <td>–</td>
                <td class="bg-primary-50"></td>
                <td class="bg-primary-50"></td>
                <td class="bg-green-50"></td>
                <td class="bg-green-50"></td>
                <td class="rounded-br"></td>
              </tr>
            } @else {
              @let dayOffClass = itineraryDayRowClass(currentItineraryExtended().items, rowIndex);
              <tr class="text-surface-800 text-xs font-['Roboto_Condensed']" [ngClass]="dayOffClass">
                @if (isFlightOnly()) {
                  <td class="font-semibold text-nowrap">{{ rowIndex === 0 ? 'First Flight' : 'Second Flight' }}</td>
                } @else {
                  <td [ngClass]="{'rounded-bl' : (rowIndex === currentItineraryExtended().items.length - 1)}">
                    <p-check-box disabled inputId="personalDay1" [binary]="true" [ngModel]="itineraryItem.isPersonalDay"></p-check-box>
                  </td>
                }
                <td>
                  <span>{{ itineraryItem.start | date:'dd/MM/yy' }}</span>
                </td>
                <td class="bg-primary-50">
                  {{ itineraryItem.startLocation?.name }}
                </td>
                <td class="bg-primary-50">
                  <span>{{ itineraryItem.start | date:'HH:mm' }}</span>
                </td>
                <td class="bg-green-50">
                  {{ itineraryItem.endLocation?.name }}
                </td>
                <td class="bg-green-50">
                  <span>{{ itineraryItem.end | date:'HH:mm' }}</span>
                </td>
                @if (!isFlightOnly()) {
                  <td>
                    {{ itineraryItem.workType}}
                  </td>
                  <td>
                    {{ itineraryItem.travelMode }}
                  </td>
                }
                <td>
                  {{ itineraryItem.supportingInfo }}
                </td>
                @if (!isFlightOnly()) {
                  <td>
                    {{ itineraryItem.accommodationType }}
                  </td>
                  <td [ngClass]="{'text-surface-400' : (itineraryItem.breakfastValue === 0)}">
                    {{ itineraryItem.breakfastValue | currency }}
                  </td>
                  <td [ngClass]="{'text-surface-400' : (itineraryItem.lunchValue === 0)}">
                    {{ itineraryItem.lunchValue | currency }}
                  </td>
                  <td [ngClass]="{'text-surface-400' : (itineraryItem.dinnerValue === 0)}">
                    {{ itineraryItem.dinnerValue | currency }}
                  </td>
                  <td [ngClass]="{'text-surface-400' : (itineraryItem.incidentalValue === 0)}">
                    {{ itineraryItem.incidentalValue | currency }}
                  </td>
                  <td [ngClass]="{'text-surface-400' : (itineraryItem.cateringValue === 0)}">
                    {{ itineraryItem.cateringValue | currency }}
                  </td>
                  @if (showOverseasColumn()) {
                    <td [ngClass]="{'text-surface-400' : !itineraryItem.overseasValue}">
                      {{ (itineraryItem.overseasValue ?? 0) | currency }}
                    </td>
                  }
                  <td [ngClass]="{'rounded-br' : (rowIndex === currentItineraryExtended().items.length - 1), 'text-surface-400' : (itineraryItem.dayTripValue === 0)}">
                    {{ itineraryItem.dayTripValue | currency }}
                  </td>
                }
              </tr>
            }
          </ng-template>
        </p-table>
        @if (!!currentItinerary()?.notes) {
          <div class="text-surface-700 text-xs font-medium font-['Inter'] leading-4 pt-2">Itinerary Notes</div>
          <div class="px-3 py-2 bg-surface-200 rounded-md w-2/3 text-sm">{{ currentItinerary()?.notes ?? '' }}</div>
        }
      </div>

    </div>

  } @else {
    <div class="w-full h-full">
      <div class="text-xs font-semibold font-['Inter'] px-4 py-2">
        Itinerary
      </div>
      <div class="text-xs font-normal font-['Inter'] leading-[9.75px] px-4 py-2">
        <i>No itinerary.</i>
      </div>
    </div>
  }
} @else {
  <div class="w-full h-full flex flex-col gap-6">
    <p-card>
      <div class="flex flex-col gap-2">
        <div class="flex w-full bg-surface-0 p-6 gap-6 rounded-t-2xl shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.10),0px_1px_3px_0px_rgba(0,0,0,0.10)]">
          <div class="flex flex-col gap-3">
            <div class="self-stretch justify-start text-surface-800 text-base font-medium font-['Inter'] leading-6">Traveller Itineraries</div>
            @if (isFlightOnly()) {
              <div class="self-stretch justify-start text-surface-600 text-sm font-light font-['Inter']">Complete the primary traveller’s itinerary for each flight.</div>
            } @else {
              <div class="self-stretch justify-start text-surface-600 text-sm font-light font-['Inter']">Complete the primary traveller’s itinerary for each day of the trip.</div>
              <div class="self-stretch justify-start text-surface-600 text-sm font-light font-['Inter']">For group travel, the itinerary will be copied for each of the other travellers but can be edited individually.</div>
            }
          </div>
          <div class="p-1">
            <ta-toast title="Out of Region Travel"
                      body="The arrival destination that you’ve selected is outside of the CLC Region. This TA will will need to be approved by the CLC CEO."
                      severity="info"
                      [visible]="showOutOfRegion()"
                      (onClose)="outOfRegionManuallyClosed.set(true)"
            ></ta-toast>
          </div>
        </div>
        @if (!!this.currentItinerary()) {
          <div class="flex flex-col gap-2 w-full bg-surface-50 p-3 rounded-b-2xl shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.10),0px_1px_3px_0px_rgba(0,0,0,0.10)]">
            <p-tabs
              [value]="selectedTravellerId()"
              (valueChange)="onTravellerTabChange($event)"
            >
              <div class="bg-white">
                <p-tablist>
                  @for (traveller of sortedTravellers(); track traveller; let ii = $index) {
                    <!-- Disabled while saving: changing tab reloads the itinerary, which is no longer
                         queued behind the row's still-saving edit and would show pre-save values. -->
                    <p-tab [value]="traveller.travellerId ?? 0" [disabled]="!allowedTab(traveller) || store.isSavingData()">
                      @if ( traveller.travellerId === taSubmission()?.primaryTraveller?.travellerId) {
                        <i class="fa fa-star text-yellow-500"></i>
                      } @else if (traveller.travellerId && this.taSubmissionDatasource.primaryLinkedUserTravellers().includes(traveller.travellerId)) {
                        <i class="fa fa-link"></i>
                      } @else {
                        <i class="fa fa-link-slash"></i>
                      }
                      <span class="pl-1">
                        {{traveller.details?.firstName + " " + traveller.details?.surname }}
                      </span>
                    </p-tab>
                  }
                </p-tablist>
              </div>
            </p-tabs>
            <div class="flex flex-col gap-4">
              <p-table [value]="flightRows()"
                       [rowTrackBy]="trackItineraryItem"
                       class="border-[1px] border-surface-200 rounded-lg">
                <ng-template #header>
                  <tr class="text-surface-800 text-xs font-semibold font-['Roboto_Condensed']">
                    @if (isFlightOnly()) {
                      <th class="rounded-tl-lg"></th>
                      <th>Date</th>
                      <th>Departing From</th>
                      <th>Flight Time</th>
                      <th>Arriving At</th>
                      <th>Arrival Time</th>
                      @if (currentItineraryExtended().isManual) {
                        <th>Work Type</th>
                      }
                      <th class="rounded-tr-lg">Flight Number</th>
                    } @else {
                      <th class="rounded-tl-lg" pTooltip="Personal Days">PD</th>
                      <th>Date</th>
                      <th>Location</th>
                      <th>Start</th>
                      <th>Location</th>
                      <th>End</th>
                      @if (currentItineraryExtended().isManual) {
                        <th>Work Type</th>
                      }
                      <th>Mode of Travel</th>
                      <th>Supporting Info</th>
                      <th>Accommodation</th>
                      <th>Meal Claims</th>
                      <th>Catering</th>
                      <th class="rounded-tr-lg w-20">Remove/ Add Days</th>
                    }
                  </tr>
                </ng-template>
                <ng-template #body let-itineraryItem let-rowIndex="rowIndex">
                  @if (itineraryItem.placeholder) {
                    <tr class="text-surface-400 text-xs font-['Roboto_Condensed'] bg-surface-100" pTooltip="Not needed - this TA is for a one-way flight" data-testid="flight-placeholder-row">
                      <td class="font-semibold text-nowrap rounded-bl-lg" style="padding-left: 12px; padding-right: 8px;">Second Flight</td>
                      <td style="padding-left: 0; padding-right: 8px;">–</td>
                      <td style="padding-left: 8px; padding-right: 0;"><input pInputText class="w-full text-xs" pSize="small" disabled placeholder="Type and/or select..."/></td>
                      <td style="padding-left: 8px; padding-right: 8px;"><input pInputText class="w-full text-xs" pSize="small" disabled/></td>
                      <td style="padding-left: 8px; padding-right: 0;"><input pInputText class="w-full text-xs" pSize="small" disabled placeholder="Type and/or select..."/></td>
                      <td style="padding-left: 8px; padding-right: 8px;"><input pInputText class="w-full text-xs" pSize="small" disabled/></td>
                      @if (currentItineraryExtended().isManual) {
                        <td></td>
                      }
                      <td class="max-w-20 rounded-br-lg" style="padding-left: 8px; padding-right: 0;"><input pInputText class="max-w-full text-xs" pSize="small" disabled placeholder="e.g. QF123"/></td>
                    </tr>
                  } @else {
                    @let dayOffClass = itineraryDayRowClass(currentItineraryExtended().items, rowIndex);
                    <tr class="text-surface-800 text-xs font-['Roboto_Condensed']" [ngClass]="dayOffClass">
                      @if (isFlightOnly()) {
                        <td class="font-semibold text-nowrap" style="padding-left: 12px; padding-right: 8px;">{{ rowIndex === 0 ? 'First Flight' : 'Second Flight' }}</td>
                      } @else {
                        <td [ngClass]="{'rounded-bl-lg' : (rowIndex === (currentItinerary()?.items?.length ?? 0) - 1)}" style="padding-left: 12px; padding-right: 0;">
                          <p-check-box
                            inputId="personalDay1"
                            [binary]="true"
                            [ngModel]="itineraryItem.isPersonalDay"
                            (ngModelChange)="updateItineraryItemField(itineraryItem, 'isPersonalDay', $event)"
                          ></p-check-box>
                        </td>
                      }
                      <td class="min-w-28 w-28" [ngClass]="{'rounded-bl-lg' : (rowIndex === (currentItinerary()?.items?.length ?? 0) - 1)}" style="padding-left: 0; padding-right: 8px;">
                        <!-- Flight dates are owned by the Travel Details step. -->
                        @if (isFlightOnly()) {
                          <span>{{ itineraryItem.start | date:'dd/MM/yy' }}</span>
                        } @else {
                          <p-datepicker panelStyleClass="text-surface-800 text-xs font-['Roboto_Condensed']"
                                        [ngModel]="itineraryItem.startDate"
                                        [iconDisplay]="'input'"
                                        [showIcon]="true"
                                        [dateFormat]="'dd/mm/y'"
                                        [readonlyInput]="true"
                                        placeholder="DD/MM/YY"
                                        size="small"
                                        appendTo="body"
                                        [disabledDates]="currentItineraryExtended().disabledDates ?? []"
                                        [minDate]="startDate()"
                                        [maxDate]="maxDate()"
                                        [invalid]="!itineraryItem.start"
                                        (onSelect)="updateItineraryDate(itineraryItem, toLocalISOString($event))"
                          >
                          </p-datepicker>
                        }
                      </td>
                      <td class="bg-primary-50 min-w-36" style="padding-left: 8px; padding-right: 0;">
                        <p-autocomplete panelStyleClass="text-surface-800 text-xs font-['Roboto_Condensed']"
                                        class="w-full"
                                        [ngModel]="itineraryItem.startLocation"
                                        [dropdown]="true"
                                        [suggestions]="filteredLocations()"
                                        (completeMethod)="filterLocations($event)"
                                        placeholder="Type and/or select..."
                                        size="small"
                                        appendTo="body"
                                        optionLabel="name"
                                        [disabled]="!itineraryItem.start"
                                        [invalid]="!itineraryItem.startLocation"
                                        (onSelect)="updateItineraryItemField(itineraryItem, 'startLocationId', $event)"
                                        (onFocus)="selectLocationText($event)"
                        >
                          <ng-template #item let-location let-i="index">
                            <span [class.location-recent-last]="i === recentLocationCount() - 1">{{ location.name }}</span>
                          </ng-template>
                        </p-autocomplete>
                      </td>
                      <td class="bg-primary-50 min-w-26 w-26" style="padding-left: 8px; padding-right: 8px;">
                        <p-datepicker #datePickerStart
                                      panelStyleClass="text-surface-800 text-xs font-['Roboto_Condensed']"
                                      inputId="calendar-timeonly"
                                      [ngModel]="itineraryItem.startDate"
                                      [timeOnly]="true"
                                      [showIcon]="true"
                                      [stepMinute]="15"
                                      [keepInvalid]="true"
                                      iconDisplay="input"
                                      (ngModelChange)="stageTime(itineraryItem, 'start')"
                                      (onClose)="commitTime(itineraryItem, 'start', datePickerStart)"
                                      (onBlur)="commitTime(itineraryItem, 'start', datePickerStart)"
                                      appendTo="body"
                                      [disabled]="!itineraryItem.start"
                                      size="small"
                        >
                          <ng-template pTemplate="inputicon">
                            <div class="pt-0.5" (mousedown)="$event.preventDefault(); datePickerStart.toggle()">
                              <i class="fa-regular fa-lg fa-clock"></i>
                            </div>
                          </ng-template>
                        </p-datepicker>
                      </td>
                      <td class="bg-green-50 min-w-36" style="padding-left: 8px; padding-right: 0;">
                        <p-autocomplete panelStyleClass="text-surface-800 text-xs font-['Roboto_Condensed']"
                                        class="w-full"
                                        [ngModel]="itineraryItem.endLocation"
                                        [dropdown]="true"
                                        [suggestions]="filteredLocations()"
                                        (completeMethod)="filterLocations($event)"
                                        placeholder="Type and/or select..."
                                        size="small"
                                        appendTo="body"
                                        optionLabel="name"
                                        [disabled]="!itineraryItem.start"
                                        [invalid]="!itineraryItem.endLocation"
                                        (onSelect)="updateItineraryItemField(itineraryItem, 'endLocationId', $event)"
                                        (onFocus)="selectLocationText($event)"
                        >
                          <ng-template #item let-location let-i="index">
                            <span [class.location-recent-last]="i === recentLocationCount() - 1">{{ location.name }}</span>
                          </ng-template>
                        </p-autocomplete>
                      </td>
                      <td class="bg-green-50 min-w-26 w-26" style="padding-left: 8px; padding-right: 8px;">
                        <p-datepicker #datePickerEnd
                                      panelStyleClass="text-surface-800 text-xs font-['Roboto_Condensed']"
                                      inputId="calendar-timeonly"
                                      [ngModel]="itineraryItem.endDate"
                                      [timeOnly]="true"
                                      [showIcon]="true"
                                      [stepMinute]="15"
                                      [keepInvalid]="true"
                                      iconDisplay="input"
                                      (ngModelChange)="stageTime(itineraryItem, 'end')"
                                      (onClose)="commitTime(itineraryItem, 'end', datePickerEnd)"
                                      (onBlur)="commitTime(itineraryItem, 'end', datePickerEnd)"
                                      [minDate]="itineraryItem.startDate"
                                      appendTo="body"
                                      [disabled]="!itineraryItem.start"
                                      size="small"
                        >
                          <ng-template pTemplate="inputicon">
                            <div class="pt-0.5" (mousedown)="$event.preventDefault(); datePickerEnd.toggle()">
                              <i class="fa-regular fa-lg fa-clock"></i>
                            </div>
                          </ng-template>
                        </p-datepicker>
                      </td>
                      @if (currentItineraryExtended().isManual) {
                        <td style="padding-left: 8px; padding-right: 0;">
                          <p-select panelStyleClass="text-surface-800 text-xs font-['Roboto_Condensed']"
                                    [options]="availableWorkTypes"
                                    [ngModel]="itineraryItem.workType"
                                    (onChange)="updateItineraryItemField(itineraryItem, 'workType', $event)"
                                    placeholder="Select..."
                                    size="small"
                                    [showClear]="true"
                                    [disabled]="false"
                                    appendTo="body"/>
                        </td>
                      }
                      @if (!isFlightOnly()) {
                        <td class="max-w-28" style="padding-left: 8px; padding-right: 0;">
                          <p-select panelStyleClass="text-surface-800 text-xs font-['Roboto_Condensed']"
                                    [options]="availableModesOfTravel"
                                    [ngModel]="itineraryItem.travelMode"
                                    (onChange)="updateItineraryItemField(itineraryItem, 'travelMode', $event)"
                                    placeholder="Select..."
                                    size="small"
                                    [showClear]="true"
                                    [disabled]="!itineraryItem.start || !itineraryItem.workType || itineraryItem.isPersonalDay"
                                    class="w-full"
                                    appendTo="body"/>
                        </td>
                      }
                      <td class="max-w-20" style="padding-left: 8px; padding-right: 0;">
                        <input class="text-surface-800 text-xs font-['Roboto_Condensed'] max-w-full"
                               type="text"
                               pInputText
                               [ngModel]="itineraryItem.supportingInfo"
                               (blur)="updateItineraryItemField(itineraryItem, 'supportingInfo', $event)"
                               [placeholder]="isFlightOnly() ? 'e.g. QF123' : itineraryItem.supportingInfoLabel ?? 'Enter...'"
                               pSize="small"
                               [disabled]="!itineraryItem.start || (!isFlightOnly() && (!itineraryItem.workType || itineraryItem.isPersonalDay))"
                        />
                      </td>
                      @if (!isFlightOnly()) {
                        <td class="max-w-28" style="padding-left: 8px; padding-right: 0;">
                          @if (itineraryItem.workType === 'Field') {
                            <p-select panelStyleClass="text-surface-800 text-xs font-['Roboto_Condensed']"
                                      class="w-full"
                                      [options]="[{value: 'Camping', label: 'Camping'},{value: 'Other', label: 'Other'}]"
                                      [ngModel]="itineraryItem.accommodationType"
                                      (onChange)="updateItineraryItemField(itineraryItem, 'accommodationType', $event)"
                                      placeholder="Select..."
                                      size="small"
                                      [showClear]="true"
                                      [disabled]="!itineraryItem.start || !itineraryItem.workType || itineraryItem.isPersonalDay"
                                      appendTo="body"/>
                          }
                          @else if (itineraryItem.workType === 'Other') {
                            <p-select panelStyleClass="text-surface-800 text-xs font-['Roboto_Condensed']"
                                      class="w-full"
                                      [options]="[{value: 'Motel', label: 'Motel'},{value: 'Private', label: 'Private'}]"
                                      [ngModel]="itineraryItem.accommodationType"
                                      (onChange)="updateItineraryItemField(itineraryItem, 'accommodationType', $event)"
                                      placeholder="Select..."
                                      size="small"
                                      [showClear]="true"
                                      [disabled]="!itineraryItem.start || !itineraryItem.workType || itineraryItem.isPersonalDay"
                                      appendTo="body"/>
                          }
                          @else {
                            <p-select panelStyleClass="text-surface-800 text-xs font-['Roboto_Condensed']"
                                      class="w-full"
                                      disabled
                                      placeholder="Select..."
                                      size="small"
                                      appendTo="body"/>
                          }
                        </td>
                        <td style="padding-left: 8px; padding-right: 0;">
                          <div class="flex gap-2">
                            <div class="flex items-center gap-1">
                              <label>B'fast</label>
                              <p-check-box
                                inputId="breakfast1"
                                [binary]="true"
                                [ngModel]="itineraryItem.mealClaims?.['breakfast']"
                                (onChange)="updateItineraryItemField(itineraryItem,'mealClaims', {'breakfast': $event.checked})"
                                [disabled]="!itineraryItem.start || !itineraryItem.allowedFields.includes(MealTypes.Breakfast)"
                              ></p-check-box>
                            </div>
                            <div class="flex items-center gap-1">
                              <label>Lunch</label>
                              <p-check-box
                                inputId="lunch1"
                                [binary]="true"
                                [ngModel]="itineraryItem.mealClaims?.['lunch']"
                                (onChange)="updateItineraryItemField(itineraryItem, 'mealClaims', {'lunch': $event.checked})"
                                [disabled]="!itineraryItem.start || !itineraryItem.allowedFields.includes(MealTypes.Lunch)"
                              ></p-check-box>
                            </div>
                            <div class="flex items-center gap-1">
                              <label>Dinner</label>
                              <p-check-box
                                inputId="dinner1"
                                [binary]="true"
                                [ngModel]="itineraryItem.mealClaims?.['dinner']"
                                (onChange)="updateItineraryItemField(itineraryItem, 'mealClaims', {'dinner': $event.checked})"
                                [disabled]="!itineraryItem.start || !itineraryItem.allowedFields.includes(MealTypes.Dinner)"
                              ></p-check-box>
                            </div>
                            @if (itineraryItem.allowedFields.includes(MealTypes.Incidentals)) {
                              <div class="flex items-center gap-1">
                                <label>Incidentals</label>
                                <p-check-box
                                  inputId="incidentals1"
                                  [binary]="true"
                                  [ngModel]="itineraryItem.mealClaims?.['incidentals']"
                                  (onChange)="updateItineraryItemField(itineraryItem, 'mealClaims', {'incidentals': $event.checked})"
                                  [disabled]="!itineraryItem.start || itineraryItem.isPersonalDay || !itineraryItem.allowedFields.includes(MealTypes.Incidentals)"
                                ></p-check-box>
                              </div>
                            }
                            @if (itineraryItem.allowedFields.includes(MealTypes.DayTrip)) {
                              <div class="flex items-center gap-1">
                                <label>Day Trip</label>
                                <p-check-box
                                  inputId="dayTrip1"
                                  [binary]="true"
                                  [ngModel]="itineraryItem.mealClaims?.['dayTrip']"
                                  (onChange)="updateItineraryItemField(itineraryItem, 'mealClaims', {'dayTrip': $event.checked})"
                                  [disabled]="!itineraryItem.start || itineraryItem.isPersonalDay || !itineraryItem.allowedFields.includes(MealTypes.DayTrip)"
                                ></p-check-box>
                              </div>
                            }
                          </div>
                        </td>
                        <td style="padding-left: 8px; padding-right: 8px;">
                          @if (itineraryItem.isOverseas) {
                            <!-- Overseas days: one ATO meals & incidentals claim in place of catering -->
                            <div class="flex gap-2 justify-center">
                              <div class="flex items-center gap-1">
                                <label>Meals &amp; Incidentals</label>
                                <p-check-box
                                  inputId="overseas1"
                                  [binary]="true"
                                  [ngModel]="itineraryItem.mealClaims?.['overseas']"
                                  (onChange)="updateItineraryItemField(itineraryItem, 'mealClaims', {'overseas': $event.checked})"
                                  [disabled]="!itineraryItem.start || itineraryItem.isPersonalDay || !itineraryItem.allowedFields.includes(MealTypes.Overseas)"
                                ></p-check-box>
                              </div>
                            </div>
                          } @else {
                            <div class="flex gap-2">
                              <div class="flex items-center gap-1 ml-1">
                                <label>CLC Catered</label>
                                <p-radiobutton class="ml-1" name="cateredGroup"
                                               [value]="'Catered'"
                                               [ngModel]="itineraryItem.cateringOption"
                                               (onClick)="updateItineraryItemField(itineraryItem, 'cateringOption', $event)"
                                               [disabled]="!itineraryItem.start || !itineraryItem.allowedFields.includes(MealTypes.Camping)"
                                               inputId="catered1"
                                ></p-radiobutton>
                              </div>

                              <div class="flex items-center gap-1 ml-1">
                                <label>Not Catered</label>
                                <p-radiobutton class="ml-1" name="cateredGroup"
                                               [value]="'NotCatered'"
                                               [ngModel]="itineraryItem.cateringOption"
                                               (onClick)="updateItineraryItemField(itineraryItem, 'cateringOption', $event)"
                                               [disabled]="!itineraryItem.start || !itineraryItem.allowedFields.includes(MealTypes.Camping)"
                                               inputId="notCatered1"
                                ></p-radiobutton>
                              </div>
                            </div>
                          }
                        </td>
                        <td [ngClass]="{'bg-surface-50': true, 'rounded-br-lg' : (rowIndex === (currentItinerary()?.items?.length ?? 0) - 1)}">
                          <div class="flex justify-center gap-1">
                            @if ((rowIndex === (currentItinerary()?.items?.length ?? 0) - 1) && (!maxItineraryItems() || (currentItinerary()?.items?.length ?? 0) < maxItineraryItems()!)) {
                              <icon-btn variant="add-primary"
                                      ariaLabel="Add itinerary row"
                                      (click)="addRow()" />
                            }
                            <icon-btn variant="minus-red"
                                    ariaLabel="Remove itinerary row"
                                    [disabled]="(currentItinerary()?.items?.length ?? 0) <= 1"
                                    (click)="removeRow(itineraryItem)" />
                          </div>
                        </td>
                      }
                    </tr>
                  }
                </ng-template>
              </p-table>

              <div class="flex gap-3 pl-2 items-center">
                <!-- Flight-only itineraries have no allowance to override. -->
                @if (canActivateManualOverride() && !isFlightOnly()) {
                    <div class="text-surface-800 text-sm font-['Roboto_Condensed']">Toggle Manual Override</div>
                    <p-toggle-switch [ngModel]="currentItineraryExtended().isManual"
                                     (ngModelChange)="updateIsManual($event)"
                                     size="small"
                    ></p-toggle-switch>
                }
              </div>

              <p-floatlabel variant="in">
                      <textarea pTextarea
                                id="in_label_itinerary_notes"
                                [ngModel]="workingNotes()"
                                (ngModelChange)="onNotesChange($event)"
                                (blur)="onNotesBlur()"
                                placeholder="Provide any additional notes to support your proposed itinerary."
                                rows="5"
                                pSize="small"
                                [autoResize]="true"
                                class="lg:w-1/2 w-full"
                      ></textarea>
                <label for="in_label_itinerary_notes">Itinerary Notes</label>
              </p-floatlabel>
            </div>

            @if (taSubmission()?.travellers?.length === 0) {
              <div class="text-surface-500 text-sm font-normal font-['Inter'] leading-4 pb-6"><i>No travellers selected in Stage 1.</i></div>
            }
          </div>
        } @else {
          <div class="flex flex-col gap-2 w-full bg-surface-50 p-3 rounded-b-2xl shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.10),0px_1px_3px_0px_rgba(0,0,0,0.10)]">
            Start and end dates need to be selected to generate an itinerary.
          </div>
        }
      </div>
    </p-card>
  </div>
}
